import { Box, Paper, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import RefreshButton from "../../../components/button/RefreshButton";
import { TableHeaderContainer } from "../../../components/container/TableHeaderContainer";
import { TableHeaderToolsContainer } from "../../../components/container/TableHeaderToolsContainer";
import { TableTitleContainer } from "../../../components/container/TableTitleContainer";
import ExportAsXLSXButton from "../../../components/export/ExportAsXLSXButton";
import { centerAlignColDef, defaultColDef, leftAlignColDef } from "../../../components/grid/columnDefinitions/columnDefinitions";
import SearchBox from "../../../components/input/SearchBox";
const CollaborateHistoryGrid = ({ title, getLogs }) => {
  const { t } = useTranslation();
  const gridRef = useRef(null);
  const [logs, setLogs] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [searchText, setSearchText] = useState("");
  const colDefs = [
    { field: "id", hide: true },
    { headerName: t("Name"), field: "item_name", ...defaultColDef, ...leftAlignColDef },
    { headerName: t("Type"), field: "item_type", ...defaultColDef, ...centerAlignColDef },
    { headerName: t("Sender"), field: "sender_name", ...defaultColDef, ...centerAlignColDef },
    { headerName: t("Receiver"), field: "receiver_name", ...defaultColDef, ...centerAlignColDef },
    { headerName: t("Timestamp"), field: "timestamp", ...defaultColDef, ...centerAlignColDef },
  ];
  useEffect(() => {
    getLogs()
      .then((res) => res.json())
      .then((data) => setLogs(data.map((d) => ({ ...d, timestamp: d.timestamp.split(" GMT")[0] }))));
  }, [refresh]);
  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setGridOption("quickFilterText", searchText);
    }
  }, [searchText]);
  return (
    <Paper variant="Table Container">
      <TableHeaderContainer>
        <TableTitleContainer>
          <Typography variant="Table Title">{title}</Typography>
        </TableTitleContainer>
        <TableHeaderToolsContainer>
          <SearchBox text={searchText} setText={setSearchText} />
          <ExportAsXLSXButton data={logs} label="Export as .xlsx" />
          <RefreshButton />
        </TableHeaderToolsContainer>
      </TableHeaderContainer>
      <Box className="ag-theme-alpine grid-container" sx={{ height: "500px" }}>
        <AgGridReact columnDefs={colDefs} rowData={logs} ref={gridRef} domLayout="normal" />
      </Box>
    </Paper>
  );
};
export default CollaborateHistoryGrid;
